import { useTranslation } from 'react-i18next';

export function RequiredFields() {
    const { t } = useTranslation();
    return (
        <div className="w-100 flex justify-end">
            <span className="flex items-center gap-1 pl-2 h-7 border-blue-500 text-xs text-gray-500 font-light">
                <span className="text-bold font-semibold">*</span>
                {t('sections.campaigns.new-campaign.required-fields')}
            </span>
        </div>
    );
}
